exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;height:auto}", ""]);

// exports
